import { DEMO_REPORTS } from '@/data/pulseDemo/reports'
import { DEMO_UPDATES } from '@/data/pulseDemo/demoUpdates'
import { prevCronRun } from './cronOccurrences'
import { demoLoadedAt } from './demoClock'
import { findDemoSource } from './findDemoSource'

const MINUTE = 60_000

const fixtureAt = (update, now) => {
  if (update.minutesAgo != null) return demoLoadedAt() - update.minutesAgo * MINUTE
  return prevCronRun(findDemoSource(update.sourceId)?.cron, now)?.getTime() ?? now
}

/** Run results, newest first: the sample runs plus any the user started. */
export function buildDemoUpdates({ runs, readUpdateIds, overrides }, now = Date.now()) {
  const fixtures = DEMO_UPDATES.map((update) => ({ ...update, at: fixtureAt(update, now) }))
  return [...runs, ...fixtures]
    .map((update) => {
      const source = findDemoSource(update.sourceId)
      return {
        ...DEMO_REPORTS[update.sourceId],
        ...update,
        sourceKind: source?.kind ?? null,
        sourceTitle: overrides[update.sourceId]?.title ?? source?.title ?? '',
        sourceApps: source?.apps ?? [],
        sourceDeleted: Boolean(overrides[update.sourceId]?.deleted),
        read: readUpdateIds.includes(update.id),
      }
    })
    .sort((a, b) => b.at - a.at)
}
